import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
const customerOrderListDetailsState = buildServiceState({
    allowEmptyRequest: false,
    key: 'customerOrderListDetails',
    requireCustomer: true,
    service: Core.GetOrder,
});
export default customerOrderListDetailsState;
//# sourceMappingURL=customer-order-list-details-state.js.map